export const ROUTERS = {
	HOME: '/',
	ABOUT_US: '/about-us',
	COURSES: '/courses',
	NEWS: '/news',
	EVENTS: '/events',
	PROUD: '/success-stories',
	ACHIEVEMENT: '/achievement',
	EXAMINATION: '/examination',
	NEW_DETAIL: '/news/:slug',
	COURSE_DETAIL: '/courses/:slug',
	EVENT_DETAIL: '/events/:slug',
	PROUD_DETAIL: '/success-stories/:slug',
	OUR_PRIDE: '/our-pride',
	ENTRANCE_EXAM: '#',
	APP_DOWNLOAD: '#',
	WEBSITE: 'http://ptedanang.com/',
	FB_FAN_PAGE: 'https://www.facebook.com/dnavietnam.ieltspte',
	FB_GROUP: 'https://www.facebook.com/groups/1196090661729792',
	TIKTOK: 'https://www.tiktok.com/@pte.dnavietnam',
	ZALO: 'https://zalo.me/2244173560093586249',
	PHONE_NUMBER: 'tel:0799441474',
	EMAIL: 'mailto:DLA.studentsuccess@gmail.com',
	CONTACT_SECTION: '#contact-section',
};

export const HEADER_NAV_ITEMS = [
	{
		label: 'Trang chủ',
		href: ROUTERS.HOME,
		hasMegaNav: false,
	},
	{
		label: 'Về DLA',
		href: ROUTERS.ABOUT_US,
		hasMegaNav: false,
	},
	{
		title: 'Cá nhân hoá đúng nghĩa',
		descriptions: [
			'DLA tin rằng mỗi học viên là một cá thể độc nhất với tiềm năng riêng biệt, và khi được khai phá đúng cách thông qua lộ trình học cá nhân hóa chuyên sâu, học viên sẽ đạt được kết quả tối ưu và trải nghiệm hành trình học tập trọn vẹn nhất.',
		],
		label: 'Khoá học cá nhân hoá',
		href: ROUTERS.COURSES,
		hasMegaNav: true,
		children: [
			{
				key: 'lt1',
				label: 'PTE cá nhân hóa',
				href: ROUTERS.COURSES,
				title: 'Khoá học PTE Cá nhân hoá chuyên sâu',
				descriptions: [
					'Sĩ số siêu nhỏ - Học phí siêu yêu',
					'Học liệu độc quyền - Đồng hành xuyên suốt',
				],
			},
			{
				key: 'lt2',
				label: 'IELTS cá nhân hóa',
				href: ROUTERS.COURSES,
				title: 'Khoá học IELTS Cá nhân hoá chuyên sâu',
				descriptions: [
					'Lộ trình riêng biệt - Học qua thực hành',
					'Định hướng chi tiết - Đồng hành xuyên suốt',
				],
			},
			{
				key: 'lt3',
				label: 'Khoá tạo nền học thuật - THCS',
				href: ROUTERS.COURSES,
			},
			{
				key: 'lt4',
				label: 'Khoá luyện thi tinh gọn - THPT',
				href: ROUTERS.COURSES,
			},
			{ key: 'pa1', label: 'Phát âm Chuyên sâu', href: ROUTERS.COURSES },
			{ key: 'gt1', label: 'Giao tiếp Quốc tế', href: ROUTERS.COURSES },
			{ key: 'gt2', label: 'Phỏng vấn visa', href: ROUTERS.COURSES },
		],
	},
	{
		title: 'Đồng hành xuyên suốt',
		descriptions: [
			'Việc học tâp không chỉ là truyền đạt tri thức mà còn là kết nối bằng sự thấu hiểu. DLA đặt sức khỏe tinh thần của học viên làm ưu tiên hàng đầu, tạo ra một môi trường nơi học viên được hỗ trợ, trân trọng và nuôi dưỡng cảm hứng học tập.',
		],
		label: 'Hơn cả một khoá học',
		hasMegaNav: true,
		href: ROUTERS.NEWS,
		subHref: ROUTERS.EVENTS,
		children: [
			{ key: 'new1', label: 'Tin tức', href: ROUTERS.NEWS },
			{ key: 'event1', label: 'Sự kiện', href: ROUTERS.EVENTS },
		],
	},
	{
		title: 'Học tập vững tiến',
		descriptions: [
			'DLA khuyến khích học viên tiến bộ từng bước và đều đặn mỗi ngày. Vì kết quả học tập không đến sau một ngày mà là quá trình tích lũy và cải thiện liên tục',
		],
		label: 'Thành công & Tự hào',
		href: ROUTERS.PROUD,
		subHref: ROUTERS.ACHIEVEMENT,
		hasMegaNav: true,
		children: [
			{
				key: 'proud1',
				label: 'Real Teaching - Real Learning',
				href: ROUTERS.PROUD,
			},
			{
				key: 'achievement1',
				label: 'Real Achievement - Real Sharing',
				href: ROUTERS.ACHIEVEMENT,
			},
		],
	},
];
